module.exports = __webpack_public_path__ + "img/Diversity-2022.fdc459b7.png";